/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import React, {
  useState,
  DragEvent,
  useEffect,
  useRef,
  useCallback,
  useInsertionEffect
} from 'react';
import localForage from 'localforage';
import {
  addMainPublicationDateTime,
  loadPost,
  setModalUiContent,
  setShowPostIdeaModal,
  transferDataToApiFormat,
  addDraggedFiles,
  trasnferPostToSliceFormat,
  setShowAiAssistant,
  enableOverlay,
  getAiTextForBrowserExtention
} from '../../redux/slices/lomavisCreator/lomavisCreator';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import { useDispatch, useSelector } from 'react-redux';
import { MAIN_COLOR_CODES, PRIMARY_DARK, ALL } from '../../config/constants';
import MediaUploadArea from '../../components/lomavisCreator/components/MediaUploadArea';
import MediaUploadPreview from '../../components/lomavisCreator/components/MediaUploadPreview';
import { useTranslate } from '@tolgee/react';
import toast from 'react-hot-toast';
import { getLocationDetails } from '../../redux/slices/location/locationDetails';
import { useParams } from 'react-router-dom';
import { CreatorTextEditor } from '../../components/lomavisCreator/components/creatorTextEditor';
import {
  BrowserExtensionData,
  CampaignType,
  LomavisCreatorConfig,
  SchedulePlanningDataType,
  publicationDelayDataType
} from '../../redux/slices/lomavisCreator/lomavisCreatorConfig';
import ProfileGroupSelect from '../../components/lomavisCreator/components/profileGroupSelect';
import PlatformsSelection from '../../components/lomavisCreator/components/platformsSelection';
import { ButtonsBar } from '../../components/lomavisCreator/components/buttonsBar';
import { PostAdditionalOptions } from '../../components/lomavisCreator/components/postAdditionalOptions/postAdditionalOptions';
import CreatorMainModals from '../../components/lomavisCreator/components/modals/creatorMainModals';
import MultipostSettings from '../../components/lomavisCreator/components/multipostSettings';
import debounce from 'lodash.debounce';
import { PostLoaderModal } from '../../components/lomavisCreator/components/postLoaderModal';
import { PostIdeaModal } from '../../components/lomavisCreator/components/modals/postIdeaModal';
import { TitleCard } from '../../components/lomavisCreator/components/typeAdditionalOptions/titleCard';
import { GeneralAdditionalOptions } from '../../components/lomavisCreator/components/typeAdditionalOptions/generalAdditionalOptions';
import {
  POST_TYPE_TEMPLATE,
  POST_TYPE_TO_PREFIX
} from '../../components/lomavisCreator/config/platformFeatures';
import InstagramGraduationStrategy from '../../components/lomavisCreator/components/InstagramGraduationStrategy';
import { HasBeenPublishedWarning } from '../../components/lomavisCreator/components/warnings/HasBeenPublishedWarning';
import { ReloadOnBackButton } from '../../components/lomavisCreator/components/reloader/ReloadOnBackButton';
import { PostHasTextOrMedia } from '../../components/lomavisCreator/config/buttonsValidatorsFunctions';
import {
  getImageDimensions,
  importAndLoadFont,
  importFont,
  parseString, useInCreator
} from '../../components/lomavisCreator/utils/helpers';

import './custom-simple-bar-left-side.css';
import './gleapButtonAdjustments.css';
import { AIassistantModal } from './ai-assistant';
import { PostBoostModal } from './post-boost';

import PublishedOn from '../../components/lomavisCreator/components/publishedOn';

import {
  LOMAVIS_TEMPLATE_POST_LOGO_PLACEHOLDER_RECTANGLE_URL,
  LOMAVIS_TEMPLATE_POST_LOGO_PLACEHOLDER_SQUARE_URL,
  MAX_MEDIA_FILES
} from '../../components/lomavisCreator/config/constants';
import {
  BrandData,
  OverlayData
} from '../../components/lomavisCreator/utils/brandOverlay';
import OverlayArea from '../../components/lomavisCreator/components/overlayArea/overlayArea';
import ApprovalModal from '../postApproval/approvalModal';
import {
  fetchGroups,
  fetchUsers,
  loadApprovalData
} from '../../redux/slices/LomavisPostApproval/lomavisPostApproval';
import { BulkPostsImportModal } from '../../components/lomavisCreator/components/modals/bulkPostsImportModal';

import moment from 'moment';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import {
  setBulkImportUiAttribute,
  setEmptyPostState
} from '../../redux/slices/bulkPostsImport';
import {
  DEFAULT_EDITOR_FONT_FAMILY,
  DEFAULT_EDITOR_FONT_URL
} from '../../components/lomavisCreator/components/contants';
import CreatorCard from '@/components/lomavisCreator/components/commonElements/creatorCard';

interface Props {}

// Define a type for your Redux state
export interface lomavisCreatorRootState {
  lomavisCreator: {
    general_post_type: string;
    uuid: string;
    quillEditors: Record<string, any>;
    cropsCache: any;
    has_been_published: boolean;
    overlay_enabled: boolean;
    ui: any;
    schedulePlanningData: SchedulePlanningDataType;
    publishingDelayData: publicationDelayDataType;
    temporaryPublishingDelayData: publicationDelayDataType;
    lomavisCreatorConfig: LomavisCreatorConfig;
    loadedMediaFiles: any[];
    platformEnabled: Record<string, boolean>;
    postTypeSelected: Record<string, string>;
    locationUuid: string | null;
    cloudUuid: string | null;
    renderedTemplateImageBlob: any[];
    mediaFiles: [];

    overlayData: OverlayData[];
    brandData: BrandData;
    createdOverlayArray: any[];

    draggedMediaFiles: [];
    mediaLibraryFiles: [];
    mediaFilesUploading: [];
    featuresEnabled: Record<string, boolean>;
    time: any;
    timeZone: any;
    is_multipost: boolean;
    accessibility_guard: boolean;
    recurrence_as_str: string;
    is_recurring_post: boolean;
    is_template_post: boolean;
    lomavisCreatorCacheReload: { is_template_post: boolean };
    publication_delay_in_minutes: number;
    useSeparateMediaFiles: boolean;
    useSeparateTextFields: boolean;
    use_separate_publication_datetime: boolean;
    uploadedImageThumbnail: any;
    use_separate_publication_datetime_date: boolean;
    use_separate_publication_datetime_time: boolean;
    all_platforms_publication_datetime_date: string;
    all_platforms_publication_datetime_time: string;
    uploadCancelToken: any;
    postData: Record<
      string,
      Record<string, string | number | boolean | any | [] | any[]>
    >;

    modalStates: any;

    allowEditorClose: boolean;
    allowMultiImageEditor: boolean;
    allowBrandEditorClose: boolean;
    allowOverlayCreatorClose: boolean;
    lastCropUpdateTimestamp: any;
    browserExtensionData: BrowserExtensionData;

    // Add post boost state
    postBoost: {
      loading: boolean;
      ui: {
        showPostBoost: boolean;
      };
      boost_config: Record<string, any>;
    };
    campaigns: CampaignType[];
    instagram_direct_connect: boolean;

  };

  // Add other slices of state here as needed
}

const LomavisCreatorPage: React.FC<Props> = () => {
  // add useeffect for auto saving lomavisCreator Post state.
  const lomavisCreator = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator
  );
  const { locationUuid, cloudUuid, is_multipost } = useSelector(
    (state: any) => state.lomavisCreator
  );
  const {
    postData,
    lomavisCreatorConfig,
    postTypeSelected,
    cropsCache,
    platformEnabled,
    overlay_enabled,
    overlayData,
    brandData,
    browserExtensionData,
    quillEditors,

    ui: { previewMode }
  } = useSelector((state: lomavisCreatorRootState) => state.lomavisCreator);

  const {
    image_urls = [],
    url = '',
    extracted_text = ''
  } = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator?.browserExtensionData ?? {
        image_urls: [],
        url: '',
        extracted_text: null
      }
  );

  const { locations } = useSelector((state: any) => state.locationsList);

  useInsertionEffect(() => {
    importFont(DEFAULT_EDITOR_FONT_URL);
  }, []);

  useEffect(() => {
    dispatch(fetchUsers({ locationUuid, cloudUuid, is_multipost }) as any);
    dispatch(fetchGroups({ locationUuid, cloudUuid, is_multipost }) as any);
  }, []);
  useEffect(() => {
    // open_lomavis_ai_assistant=true is a query param that opens the AI assistant modal
    const urlParams = new URLSearchParams(window.location.search);
    const openAiAssistant = urlParams.get('open_lomavis_ai_assistant');
    if (openAiAssistant) {
      dispatch(setShowAiAssistant(true));
    }
  }, []);

  useEffect(() => {
    const currentUrl = window.location.href;
    const urlObj = new URL(currentUrl);
    const params = new URLSearchParams(urlObj.search);

    // Get the datetime value
    const datetime = params.get('all_platform_publish_datetime');

    if (datetime && parseString(datetime)) {
      const date = moment(datetime).format();

      dispatch(
        addMainPublicationDateTime({
          platform: ALL,
          dateTime: date
        })
      );
    }
  }, []);

  const onPostLoad = async () => {
    const key = `${lomavisCreator.locationUuid}_${lomavisCreator.cloudUuid}_${lomavisCreator.is_multipost}_${lomavisCreator.uuid}`;
    // check if we have key in the localstorage??
    const data: any = await localForage.getItem(key);
    // load the data to the state
    if (data) {
      dispatch(loadPost(data?.data) as any);
      const approvalConfig = data?.data?.approval_process;
      if (approvalConfig) {
        dispatch(loadApprovalData(approvalConfig));
      }
    }
    setShowLoadPostModal(false);
  };

  const onPostDiscard = async () => {
    const key = `${lomavisCreator.locationUuid}_${lomavisCreator.cloudUuid}_${lomavisCreator.is_multipost}_${lomavisCreator.uuid}`;
    await localForage.removeItem(key);
    setShowLoadPostModal(false);
  };
  const TIMEOUTFORAUTOSAVE = 1500;

  const debounceSaveToLocalForage = useCallback(
    debounce(async (data, key) => {
      try {
        localForage.setItem(key, {
          data,
          timestamp: new Date().getTime()
        });
        console.log('Saved to local storage');
      } catch (error) {
        console.error('Error saving to local storage', error);
      }
    }, TIMEOUTFORAUTOSAVE),
    []
  );
  const finshedCacheCheck = useRef(false);
  const cachedPostHasMediaOrText = async (key) => {
    const lomavisCreatorState: any = await localForage.getItem(key);
    if (!lomavisCreatorState) return false;
    const data = lomavisCreatorState?.data;

    const loadableFormat = trasnferPostToSliceFormat(data);
    const hasMediaOrText = PostHasTextOrMedia(loadableFormat);
    return hasMediaOrText.map((item) => item.isValid).includes(true);
  };

  useEffect(() => {
    const checkStorage = async () => {
      const key = `${lomavisCreator.locationUuid}_${lomavisCreator.cloudUuid}_${lomavisCreator.is_multipost}_${lomavisCreator.uuid}`;
      const showLoadModalInitValue =
        !isUpdate && !urlQueryParams.get('all_platform_publish_datetime');
      const hasMediaOrText = await cachedPostHasMediaOrText(key);
      setShowLoadPostModal(
        showLoadModalInitValue &&
          hasMediaOrText &&
          !isImport &&
          !(
            browserExtensionData &&
            browserExtensionData?.image_urls?.urls?.length > 0
          )
      );
      finshedCacheCheck.current = true;
    };
    void checkStorage();
  }, []);
  useEffect(() => {
    if (
      browserExtensionData &&
      browserExtensionData?.image_urls?.urls?.length > 0
    ) {
      dispatch(
        setModalUiContent({
          modal: 'browserPlugin',
          attribute: 'toggle',
          value: true
        })
      );
    }
  }, [browserExtensionData]);
  useEffect(() => {
    const data = transferDataToApiFormat(lomavisCreator, null, locations);

    // the current data object is empty. We will use this one as template to be used with bulk post imports
    if (!lomavisCreator.lomavisCreatorConfig.is_update) {
      dispatch(setEmptyPostState(data));
    }

    if (!finshedCacheCheck.current) return;
    if (isUpdate) {
      return;
    }
    if (showLoadPostModal) return;

    const key = `${lomavisCreator.locationUuid}_${lomavisCreator.cloudUuid}_${lomavisCreator.is_multipost}_${lomavisCreator.uuid}`;
    debounceSaveToLocalForage(data, key);
  }, [lomavisCreator]);

  const { t } = useTranslate();
  const dispatch = useDispatch<ThunkDispatch<any, any, AnyAction>>();
  const { locationslug } = useParams();
  const mainDragRef = useRef(null);
  const sortableListRef = useRef(null);

  const [selectedEditorPlatform, setSelectedEditorPlatform] = useState('');
  const useSeparateMediaFiles = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.useSeparateMediaFiles
  );

  const isUpdate = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.lomavisCreatorConfig.is_update
  );

  const isImport = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.lomavisCreatorConfig.importing_post
  );
  const {
    ui: { uploadAreaVisible, showAiAssistant, showPostBoost }
  } = useSelector((state: lomavisCreatorRootState) => state.lomavisCreator);
  const {
    ui: { showPostApprovalCreatorModal }
  } = useSelector((state: any) => state.lomavisPostApproval);

  useEffect(() => {
    if (locationslug) dispatch(getLocationDetails(locationslug) as any);
    // if edit url is used, get the post data from dom
    if (isUpdate || isImport) {
      const postData = JSON.parse(
        document.getElementById('lomavis_creator_post_instance_data')
          .textContent
      );

      console.log('load post', postData);

      if (isImport) {
        postData.uuid = null;
        postData.post_status = null;
      }

      dispatch(loadPost(postData) as any);

      // check if we have post_idea in the data and show the modal
      if (postData.post_idea) {
        dispatch(setShowPostIdeaModal(true));
      }
    }
  }, []);

  const [dragIsOver, setDragIsOver] = useState(false);

  const overlay_is_enabled = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.general_post_type === POST_TYPE_TEMPLATE ||
      overlay_enabled
  );

  const handleEditorPlatformToggle = (
    platform,
    mediaFiles,
    currentIndex = null
  ) => {
    const overlay_is_enabled =
      lomavisCreator.general_post_type === POST_TYPE_TEMPLATE;
    const checkIfOverlayIsApplied = mediaFiles?.some(
      (item) => item.apply_brand_overlay === true
    );
    if (
      overlay_is_enabled ||
      (overlayData.length > 0 && checkIfOverlayIsApplied)
    ) {
      dispatch(
        setModalUiContent({
          modal: 'brandMediaEditor',
          attribute: 'toggle',
          value: true
        })
      );
      dispatch(
        setModalUiContent({
          modal: 'brandMediaEditor',
          attribute: 'platform',
          value: platform
        })
      );
      dispatch(
        setModalUiContent({
          modal: 'brandMediaEditor',
          attribute: 'currentIndex',
          value: currentIndex
        })
      );
    } else {
      dispatch(
        setModalUiContent({
          modal: 'mediaEditor',
          attribute: 'toggle',
          value: true
        })
      );
      dispatch(
        setModalUiContent({
          modal: 'mediaEditor',
          attribute: 'platform',
          value: platform
        })
      );
      dispatch(
        setModalUiContent({
          modal: 'mediaEditor',
          attribute: 'currentIndex',
          value: currentIndex
        })
      );
    }
  };

  const handleMediaView = (platform, currentIndex = null) => {
    dispatch(
      setModalUiContent({
        modal: 'mediaViewer',
        attribute: 'toggle',
        value: true
      })
    );
    dispatch(
      setModalUiContent({
        modal: 'mediaViewer',
        attribute: 'platform',
        value: platform
      })
    );
    dispatch(
      setModalUiContent({
        modal: 'mediaViewer',
        attribute: 'currentIndex',
        value: currentIndex
      })
    );
  };

  useEffect(() => {
    if (overlayData.length > 0 && !overlay_enabled) {
      dispatch(enableOverlay({ value: true }));
    }
  }, [overlayData]);

  // const findAllEditorUploadState = () => {
  //   let array = [];
  //   for (const p of PLATFORM_LIST) {
  //     if (platformEnabled[p] && postData[p]?.media) {
  //       const mediaUploadState = postData[p].media.map(
  //         (item) => item?.editorUpdateState
  //       );

  //       array.push(mediaUploadState);
  //     }
  //   }
  //   return array;
  // };
  // const arrayOfeditorUploadStates = findAllEditorUploadState();

  const socialMediaWithPosts = Object.keys(postData).filter(
    (type) =>
      (postData[type].media as any[]) &&
      (postData[type].media as any[]).length > 0
  );
  const [items, setItems] = useState([]);
  const postHasGeneralAdditionalOptions = () => {
    return Object.keys(POST_TYPE_TO_PREFIX).includes(
      lomavisCreator.general_post_type
    );
  };
  // Define the event handlers
  const handleDragOver = (event) => {
    event.preventDefault();
    if (
      sortableListRef.current &&
      sortableListRef.current.contains(event.target)
    ) {
      return;
    }
    setDragIsOver(true);
  };

  const handleDragLeave = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();

    const relatedTarget = event.relatedTarget as Node | null;

    // Only reset drag if relatedTarget is outside the currentTarget (the drop zone)
    if (!relatedTarget) {
      setDragIsOver(false);
    }
  };

  const handleDrop = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();

    setDragIsOver(false);

    // console.log(
    //   "Post data media length",
    //   postData["all"].media?.length,
    //   items?.length
    // );

    const files = Array.from(event.dataTransfer.files);

    const allowedTypes = overlay_is_enabled
      ? [
          'image/jpeg',
          'image/png',
          'image/jpg',
          'image/heic',
          'image/heif',
          'image/heic-sequence',
          'image/heif-sequence'
        ]
      : [
          'image/jpeg',
          'image/png',
          'image/jpg',
          'image/heic',
          'image/heif',
          'image/heic-sequence',
          'image/heif-sequence',
          'video/mov',
          'video/quicktime',
          'video/mp4',
          'application/pdf'
        ]; // Define allowed file types
    const filteredFiles = files.filter((file) =>
      allowedTypes.includes(file.type)
    );

    if (
      Array.isArray(postData.all.media) &&
      postData.all.media?.length + filteredFiles?.length <= MAX_MEDIA_FILES
    ) {
      handleUpload(filteredFiles);
      filteredFiles.map((item) => {
        items.includes(item) ? '' : setItems([...items, item]);
      });
    } else {
      toast.error(`${t('errors.max_limit_reached')}`, {
        duration: 4000,
        position: 'top-right'
      });

      console.error(
        `Maximum limit (${MAX_MEDIA_FILES}) reached!`,
        postData.all.media?.length,
        filteredFiles?.length
      );
    }
  };

  const handleUpload = (filteredFiles: any[]) => {
    dispatch(
      addDraggedFiles({
        platform: ALL,
        files: filteredFiles
      })
    );
  };

  useEffect(() => {
    // adjust root classes to fill up 100% of the screen. Other pages could be affected by a global change,
    // so we only do it here
    const root = document.getElementById('root');
    root.classList.add('h-100', 'd-flex', 'flex-column');
  });

  // get all url query params
  const urlQueryParams = new URLSearchParams(window.location.search);
  const [showLoadPostModal, setShowLoadPostModal] = useState(false);
  useEffect(() => {
    getImageDimensions(LOMAVIS_TEMPLATE_POST_LOGO_PLACEHOLDER_SQUARE_URL);
    getImageDimensions(LOMAVIS_TEMPLATE_POST_LOGO_PLACEHOLDER_RECTANGLE_URL);
    importFont(DEFAULT_EDITOR_FONT_URL);
    if (brandData?.fonts?.fontFaceUrl) {
      importFont(brandData.fonts.fontFaceUrl);
    }

    const checkStorage = async () => {
      const key = `${lomavisCreator.locationUuid}_${lomavisCreator.cloudUuid}_${lomavisCreator.is_multipost}_${lomavisCreator.uuid}`;

      // clear the local storage if we are importing a post
      if (isImport || urlQueryParams.get('all_platform_publish_datetime')) {
        await localForage.removeItem(key);
      }
    };
    void checkStorage();
  }, []);

  //Handle AiText updates for browser extension
  const [aiGeneratedText, setAiGeneratedText] = useState('');
  useEffect(() => {
    if (browserExtensionData && quillEditors[ALL] && aiGeneratedText) {
      useInCreator(aiGeneratedText, quillEditors[ALL], t);
    }
  }, [quillEditors[ALL], aiGeneratedText]);

  useEffect(() => {
    if (!extracted_text) {
      return;
    }
    const fetchAiText = async () => {
      try {
        const result = await dispatch(
          getAiTextForBrowserExtention(url, extracted_text)
        );
        setAiGeneratedText(result[0]?.response);
      } catch (error) {
        console.error('Error fetching AI text:', error);
      }
    };
    if (browserExtensionData && url && extracted_text) {
      fetchAiText();
    }
  }, [url, extracted_text, browserExtensionData]);

  useEffect(() => {
    const loadFonts = async () => {
      const DEFAULT_EDITOR_FONT_FACE = `normal 400 16px ${DEFAULT_EDITOR_FONT_FAMILY}`;
      const BRAND_EDITOR_FONT_FACE = `normal 400 16px ${brandData.fonts.fontFamily}`;

      await importAndLoadFont(
        DEFAULT_EDITOR_FONT_URL,
        DEFAULT_EDITOR_FONT_FACE
      );
      if (brandData?.fonts?.fontFaceUrl) {
        await importAndLoadFont(
          brandData.fonts.fontFaceUrl,
          BRAND_EDITOR_FONT_FACE
        );
      }

      console.log('All required fonts loaded');
    };

    void loadFonts();
  }, [brandData]);

  useEffect(() => {
    const loadFonts = async () => {
      const DEFAULT_EDITOR_FONT_FACE = `normal 400 16px ${DEFAULT_EDITOR_FONT_FAMILY}`;
      const BRAND_EDITOR_FONT_FACE = `normal 400 16px ${brandData.fonts.fontFamily}`;

      await importAndLoadFont(
        DEFAULT_EDITOR_FONT_URL,
        DEFAULT_EDITOR_FONT_FACE
      );
      if (brandData?.fonts?.fontFaceUrl) {
        await importAndLoadFont(
          brandData.fonts.fontFaceUrl,
          BRAND_EDITOR_FONT_FACE
        );
      }

      console.log('All required fonts loaded');
    };

    void loadFonts();
  }, [brandData]);

  // get element by id to get height
  const navBarHeight =
    document.getElementById('kt_app_header')?.clientHeight + 15 * 2 + 50;

  return (
    <div
      className={'d-flex flex-column h-100 mh-100'}
      onDragOver={
        uploadAreaVisible && !useSeparateMediaFiles
          ? (e) => {
              handleDragOver(e);
            }
          : () => {}
      }
      ref={mainDragRef}
      onDragLeave={handleDragLeave}
      onDrop={(event) => {
        event.preventDefault();
        setDragIsOver(false);
      }}
    >
      <link href={DEFAULT_EDITOR_FONT_URL} rel="stylesheet"></link>
      <link href={brandData?.fonts?.fontFaceUrl} rel="stylesheet"></link>
      <ReloadOnBackButton />
      <PostIdeaModal handleClose={() => {}} />
      <BulkPostsImportModal
        handleClose={() =>
          dispatch(
            setBulkImportUiAttribute({
              attribute: 'showImportModal',
              value: false
            })
          )
        }
      />
      <PostLoaderModal
        onClose={async () => {
          await onPostDiscard();
        }}
        isOpen={showLoadPostModal}
        onPostLoad={async () => {
          await onPostLoad();
        }}
        onPostDiscard={async () => {
          await onPostDiscard();
        }}
      />
      <ProfileGroupSelect />
      {dragIsOver && (
        <div
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          style={{
            width: '100vh',
            height: '100wh',
            zIndex: 110,
            top: '1px',
            left: '1px'

            // backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
          className="underlay position-absolute w-100 h-100 d-flex justify-content-center justify-content-center "
        ></div>
      )}
      <div
        className={'d-flex flex-row h-100 w-100 position-relative'}
        style={{
          height: `calc(100dvh - ${navBarHeight}px)`,
          minHeight: `calc(100dvh - ${navBarHeight}px)`,
          maxHeight: `calc(100dvh - ${navBarHeight}px)`
        }}
      >
        {dragIsOver && (
          <div
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            style={{
              zIndex: 110,
              top: '0px',
              left: '0px',

              backgroundColor: 'rgba(255, 255, 255, 0.9)'
            }}
            className="underlay position-absolute w-100 h-100 d-flex justify-content-center justify-content-center "
          >
            <div
              style={{
                width: '100%',
                height: '200px',
                top: '50%',
                transform: 'translateY(-50%)',
                textAlign: 'center',
                position: 'relative',
                zIndex: 1 // Ensure text is on top of the semi-transparent background
              }}
              className="text-dark d-flex flex-column gap-3"
            >
              <i
                className="fa-solid fa-cloud-arrow-up"
                style={{
                  color: MAIN_COLOR_CODES[PRIMARY_DARK],
                  fontSize: '9rem'
                }}
              ></i>
              <p
                style={{ color: MAIN_COLOR_CODES[PRIMARY_DARK] }}
                className="fs-1 fw-bold"
              >
                {t('creator.text.drop_files_here')}
              </p>
              <p
                style={{ color: MAIN_COLOR_CODES[PRIMARY_DARK] }}
                className="fw-bolder"
              >
                {t('lomavisCreator.dragAndDroptext.max_10_file')}
              </p>
            </div>
          </div>
        )}

        <div
          className={'d-flex h-100 w-50 position-relative'}
          style={{
            minWidth: '50%',
            maxWidth: '50%',
            maxHeight: `calc(100dvh - ${navBarHeight}px)`
          }}
        >
          <div
            style={{ maxWidth: '100%' }}
            className={
              'd-flex flex-column w-100 pe-0 flex-fill bg-secondary rounded rounded-bottom-0 rounded-top-end-0 leftSideElm'
            }
          >
            <SimpleBar
              className={'pe-3'}
              style={{ maxHeight: `calc(100dvh - ${navBarHeight}px)` }}
            >
              <div style={{ height: '0.5em' }}></div>
              <HasBeenPublishedWarning />
              <PlatformsSelection />
              <PublishedOn />
              {postHasGeneralAdditionalOptions() && (
                <TitleCard
                  prefix={
                    POST_TYPE_TO_PREFIX?.[lomavisCreator.general_post_type]
                  }
                />
              )}
              {/** Put graduation strategy here */}

              <InstagramGraduationStrategy />

              <CreatorTextEditor />
              <div>
                <MediaUploadArea sortableListRef={sortableListRef} />
              </div>
              {lomavisCreator.general_post_type === POST_TYPE_TEMPLATE && (
                <OverlayArea></OverlayArea>
              )}

              <PostAdditionalOptions />

              {postHasGeneralAdditionalOptions() && (
                <GeneralAdditionalOptions
                  prefix={
                    POST_TYPE_TO_PREFIX?.[lomavisCreator.general_post_type]
                  }
                />
              )}
              {lomavisCreatorConfig.is_multipost && <MultipostSettings />}
              <div style={{ height: '0.5em' }}></div>
            </SimpleBar>
          </div>
        </div>
        <div
          style={{
            width: '100%',
            position: 'relative',
            maxHeight: `calc(100dvh - ${navBarHeight}px)`
          }}
          className="d-flex flex-column w-100 bg-dark position-relative w-100"
        >
          <MediaUploadPreview
            platformEditorSwitch={handleEditorPlatformToggle}
            handleMediaView={handleMediaView}
          />
          <div className="mt-5" />
        </div>
      </div>

      <div
        style={{ height: '50px' }}
        className="w-100 d-flex align-items-center"
      >
        <ButtonsBar />
      </div>
      <CreatorMainModals selectedEditorPlatform={selectedEditorPlatform} />
      {showAiAssistant && <AIassistantModal />}
      {showPostBoost && <PostBoostModal />}
      {showPostApprovalCreatorModal && <ApprovalModal />}
    </div>
  );
};

export default LomavisCreatorPage;
